import { render, staticRenderFns } from "./NewsWidget.vue?vue&type=template&id=b68f86dc&"
import script from "./NewsWidget.vue?vue&type=script&lang=js&"
export * from "./NewsWidget.vue?vue&type=script&lang=js&"
import style0 from "./NewsWidget.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports